import { defineComponent, onMounted, ref, useContext, useCssModule, watch } from '@nuxtjs/composition-api';
import { SHOULD_DISABLE } from '~/plugins/adfox';
import { parseAdfoxHTML } from '~/utils';
export default defineComponent({
    name: 'CardArticleAdfox',
    props: {
        data: {
            required: true,
            type: Object,
        },
        options: {
            default: () => {
                return {};
            },
            type: Object,
        },
        size: {
            required: true,
            type: Object,
        },
    },
    setup() {
        /**
         * CSS Composables.
         */
        const context = useContext();
        const css = useCssModule();
        /**
         * Context
         */
        const adfoxLoader = context.$adfoxLoader;
        const rootEl = ref();
        const shouldRender = ref(!SHOULD_DISABLE);
        const adfoxArticle = ref();
        function onComplete({ state }) {
            shouldRender.value = !(state.withError || state.withStub);
            if (!rootEl.value || !shouldRender.value) {
                return;
            }
            const adfoxEl = rootEl.value.querySelector('[id^="adfox"]');
            if (!adfoxEl) {
                return;
            }
            // Parse HTMl in Adfox container
            adfoxArticle.value = parseAdfoxHTML(adfoxEl);
        }
        onMounted(() => {
            watch(() => adfoxLoader.error, (isError) => {
                if (isError) {
                    shouldRender.value = false;
                }
            }, { immediate: true });
        });
        return {
            adfoxArticle,
            css,
            onComplete,
            rootEl,
            shouldRender,
        };
    },
});
